module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/costume_type_both_costume@2x-cac71a55a9ee6a5e63072132c0347d64.webp";